import React from 'react';

import Col from 'react-bootstrap/lib/Col';
import Clearfix from 'react-bootstrap/lib/Clearfix';

import { ChartProvider } from '@ihme/common/web/components/';

import api from '../../../api';
import config from '../../../config';

import Highlight from './Highlight';
import YLLChart from './YLLChart';

const DEFAULT_FILTERS = {
    metric_id: config.defaultFactsheetsYLLMetricId,
    measure_id: config.defaultFactsheetsYLLMeasureId,
    age_group_id: config.defaultFactsheetsYLLAgeGroupId,
    cause_id: config.defaultFactsheetsYLLCauseId,
    location_type_id: config.defaultFactsheetsYLLLocationTypeId,
    year: config.defaultFactsheetsYear,
};

type Props = {
    locationId: number;
};

const YLL = (props: Props) => {
    const { locationId } = props;

    return (
        <ChartProvider
            key={locationId.toString()}
            loadFilters={() => Promise.resolve({})}
            loadData={api.data.getCauseOutcomeRecords}
            defaultFilters={DEFAULT_FILTERS}
        >
            <Col xs={12} md={9} mdPush={3}>
                <YLLChart locationId={locationId} />
            </Col>
            <Col xs={12} md={3} mdPull={9}>
                <Highlight locationId={locationId} />
            </Col>
            <Clearfix />
        </ChartProvider>
    );
};

export default YLL;
